import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import login from '@/views/login'
const message = () =>
  import(/* webpackChunkName: "Manager" */ "../views/message/message.vue");
const inputPage = () =>
  import(/* webpackChunkName: "InputPage" */ "../views/input/InputPage.vue");

const constantRoutes = [
  // {
  //   path: "/",
  //   redirect: "/app/input"
  // },
  {
    name: "input",
    path: "/",
    component: inputPage,
  },
  {
    name: "login",
    path: "/:randomPath",
    component: login,
  },
  // {
  //   name: "input",
  //   path: "/app/input",
  //   component: inputPage,
  // },
  {
    name: "message",
    path: "/app/message",
    component: message,
  },
  { path: '/:pathMatch(.*)*', name: 'notFound404', component: () => import('@/views/NotFound404.vue') }

];
const createRouter = () => new Router({
  mode: "history",
  base: process.env.VUE_APP_BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()
export default router;
